import React, { useState } from "react";
import { FiMapPin, FiNavigation, FiPhone } from "react-icons/fi";
import Location_pic from "./Location_pic";

// Opens Google Maps searching for the outlet by name
const mapsSearch = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

// Opens Google Maps directions to an exact street address
const mapsDirections = (address) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

// Opens a specific Google Maps listing by its place ID (cid)
const mapsListing = (cid) => `https://maps.google.com/?cid=${cid}`;


const regionLocations = {

  "Delhi NCR": [
     {
      address: "Shop No.19, New Market, Malviya Nagar, New Delhi 110017",
      phone: "9821176930",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Malviya Nagar New Delhi"),
     },
    {
      address: "The Corenthum, Sector 62, Noida, Uttar Pradesh 201301",
      phone: "9899080100",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsListing("12494430793683523619"),
    },
    {
      address: "Shiv Nadar University, Noida, Uttar Pradesh",
      phone: "9773857436",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink:
        "https://www.google.com/maps/place/Grub+Squaare+By+GreeNox/@28.5263782,77.5748376,17z/data=!4m6!3m5!1s0x390c95003c53bef5:0x28a7656a3eff620d!8m2!3d28.5263782!4d77.5748376!16s%2Fg%2F11z3k4v2n1",
    },
    {
      address: "Christ University, Delhi NCR Campus, Noida, Uttar Pradesh",
      phone: "9811571646",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Christ University Delhi NCR Ghaziabad"),
    },
    {
      address:
        "Mangalmay College, Knowledge Park II, Greater Noida, Uttar Pradesh",
      phone: "8368650750",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Mangalmay Knowledge Park II Greater Noida"),

    },
    {
      address:
        "Amity University, Knowledge Park-III, Greater Noida, Uttar Pradesh",
      phone: "8920352016",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Amity University Greater Noida"),

    },
    {
      address: "Sector-18, Vasundhara, Ghaziabad, Uttar Pradesh 201012",
      phone: "7078548120",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsDirections(
        "GreeNox, S-8, Gardenia Geetanjali Market, Maharaja Agrasen Marg, Sector 18, Vasundhara, Ghaziabad, Uttar Pradesh 201012"
      ),

    },
    {
      address:
        "S-1, 4/15, Sector-5, Rajendra Nagar, Ghaziabad 201005, Uttar Pradesh",
      phone: "9625754646",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsListing("14477473631085508326"),

    },
    {
      address:
        "639, Shakti Khand 4, Indirapuram, Ghaziabad, Uttar Pradesh 201014",
      phone: "9315700833",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsListing("937210292949630935"),

    },
    {
      address:
        "Orbit Plaza, Crossing Republik, Ghaziabad, Uttar Pradesh 201016",
      phone: "9634504777",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Orbit Plaza Crossing Republik Ghaziabad"),

    },
    {
      address: "SK-66, Sector 112, Noida, Uttar Pradesh 201304",
      phone: "9211577272",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Sector 112 Noida"),

    },
  
    {
      address: "World Trade Tower, Sector 16, Noida, Uttar Pradesh 201301",
      phone: "8800123580",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox World Trade Tower Sector 16 Noida"),

    },
  ],
  Haryana: [
    {
      address: "Ashoka University, Sonipat, Haryana 131029",
      phone: "9266871146",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Ashoka University Sonipat"),

    },
    {
      address: "Unitech Trade Centre, Sector 43, Gurugram, Haryana 122002",
      phone: "9919575355",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox Unitech Trade Centre Sector 43 Gurugram"),

    },
    {
      address:
        "SBI Card, DLF Infinity Towers, Cyber City, Gurugram, Haryana 122002",
      phone: "8810389393",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: mapsSearch("GreeNox DLF Infinity Towers Cyber City Gurugram"),

    },
    {
      address: "BML Munjal University, Kapriwas, Haryana 122413",
      phone: "8800401958",
      dinein: "OPEN",
      delivery: "OPEN",
      locationLink: "https://www.google.com/maps/place/GreeNox/data=!4m2!3m1!1s0x0:0x1a7021febf990e0a?sa=X&ved=1t:2428&ictx=111",
    }
   
  ],

  // Mumbai: [],
  // Bangalore: [],
  // Kolkata: [],
  // Chennai: [],
  // Hyderabad: [],
  // Pune: [],
};

const cityLocations = {
  "Delhi NCR": [
    ...regionLocations["Delhi NCR"],
    ...regionLocations.Haryana,
  ],
  Delhi: regionLocations["Delhi NCR"].filter((location) =>
    /New Delhi/i.test(location.address)
  ),
  Ghaziabad: regionLocations["Delhi NCR"].filter((location) =>
    /Ghaziabad/i.test(location.address)
  ),
  Noida: regionLocations["Delhi NCR"].filter((location) =>
    /Noida/i.test(location.address)
  ),
  Gurgaon: regionLocations.Haryana,
};

const cities = Object.keys(cityLocations);

// Phones show a short list with a "show all" toggle instead of a nested scroll area
const MOBILE_PREVIEW_COUNT = 4;

const formatPhone = (phone) => `+91 ${phone.slice(0, 5)} ${phone.slice(5)}`;

const getDirectionsHref = (loc) =>
  loc.locationLink ||
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(loc.address)}`;

const Location = () => {
  const [selectedCity, setSelectedCity] = useState("Delhi NCR");
  const [showAll, setShowAll] = useState(false);
  const selectedLocations = cityLocations[selectedCity];

  const selectCity = (city) => {
    setSelectedCity(city);
    setShowAll(false);
  };

  return (
    <section className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="story-hero-head mb-3 text-base font-bold uppercase tracking-wide text-gray-900 md:text-lg">
            Visit Us
          </p>
          <h2 className="story-hero-head text-[2rem] font-bold uppercase leading-[1.1] text-[#1f5c33] sm:text-[2.5rem] md:text-5xl">
            Find us at
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-gray-700 md:text-base">
            Fresh bowls and salads, prepared daily on campuses, in offices and
            around the neighbourhood across Delhi NCR and Haryana.
          </p>
        </div>

        {/* City filter: scrolls sideways on small screens */}
        <div
          role="group"
          aria-label="Filter outlets by city"
          className="-mx-4 mt-8 flex gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:flex-wrap sm:justify-center sm:px-0 md:mt-10"
        >
          {cities.map((city) => {
            const isActive = city === selectedCity;
            return (
              <button
                key={city}
                type="button"
                onClick={() => selectCity(city)}
                aria-pressed={isActive}
                className={`inline-flex h-10 shrink-0 items-center gap-2 rounded-full border px-5 text-sm font-semibold transition ${
                  isActive
                    ? "border-green-800 bg-green-800 text-white shadow-md"
                    : "border-[#1f5c33]/15 bg-white text-[#1f5c33] hover:border-[#1f5c33]/40 hover:bg-[#eef5ef]"
                }`}
              >
                {city}
                <span
                  className={`rounded-full px-1.5 text-xs ${
                    isActive ? "bg-white/20" : "bg-[#eef5ef]"
                  }`}
                >
                  {cityLocations[city].length}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid gap-6 md:mt-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-8">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <Location_pic />
          </div>

          {selectedLocations.length > 0 ? (
            <div>
              <ul className="custom-scrollbar grid gap-4 sm:grid-cols-2 lg:max-h-[640px] lg:overflow-y-auto lg:pr-3">
                {selectedLocations.map((loc, idx) => (
                  <li
                    key={loc.address}
                    className={`flex flex-col rounded-2xl border border-[#1f5c33]/10 bg-white p-5 shadow-sm transition hover:border-[#1f5c33]/25 hover:shadow-md ${
                      !showAll && idx >= MOBILE_PREVIEW_COUNT ? "hidden sm:flex" : ""
                    }`}
                  >
                    <div className="flex items-start gap-3">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#eef5ef] text-[#1f5c33]">
                        <FiMapPin aria-hidden="true" />
                      </span>
                      <p className="text-[15px] font-semibold leading-snug text-gray-900">
                        {loc.address}
                      </p>
                    </div>

                    <div className="mt-4 flex flex-wrap gap-2 text-xs font-semibold">
                      {[
                        ["Dine-in", loc.dinein],
                        ["Delivery", loc.delivery],
                      ].map(([label, status]) => {
                        const isOpen = status === "OPEN";
                        return (
                          <span
                            key={label}
                            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 ${
                              isOpen ? "bg-[#eef5ef] text-[#1f5c33]" : "bg-gray-100 text-gray-500"
                            }`}
                          >
                            <span
                              aria-hidden="true"
                              className={`h-1.5 w-1.5 rounded-full ${isOpen ? "bg-green-600" : "bg-gray-400"}`}
                            />
                            {label} {isOpen ? "available" : "unavailable"}
                          </span>
                        );
                      })}
                    </div>

                    <div className="mt-auto grid grid-cols-2 gap-2 pt-5">
                      <a
                        href={`tel:+91${loc.phone}`}
                        aria-label={`Call ${formatPhone(loc.phone)}`}
                        className="inline-flex h-11 items-center justify-center gap-2 rounded-full border border-[#1f5c33]/20 px-3 text-sm font-semibold text-[#1f5c33] transition hover:bg-[#eef5ef]"
                      >
                        <FiPhone aria-hidden="true" />
                        Call
                      </a>
                      <a
                        href={getDirectionsHref(loc)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-green-800 px-3 text-sm font-semibold text-white transition hover:bg-green-700"
                      >
                        <FiNavigation aria-hidden="true" />
                        Directions
                      </a>
                    </div>
                  </li>
                ))}
              </ul>

              {!showAll && selectedLocations.length > MOBILE_PREVIEW_COUNT && (
                <button
                  type="button"
                  onClick={() => setShowAll(true)}
                  className="mt-4 inline-flex h-11 w-full items-center justify-center rounded-full border border-[#1f5c33]/20 text-sm font-semibold text-[#1f5c33] transition hover:bg-[#eef5ef] sm:hidden"
                >
                  Show all {selectedLocations.length} outlets
                </button>
              )}
            </div>
          ) : (
            <p className="rounded-2xl bg-[#f5f3ee] px-6 py-12 text-center text-gray-700">
              No outlets in {selectedCity} yet. We're growing, so check back soon.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Location;
